import UserLoginTemplate from "./UserLoginTemplate";

export default UserLoginTemplate;
